import { isomorphicHttpClient } from "../httpClient";

export const getTenant = async (tenantId: string) => {
  const httpClient = isomorphicHttpClient();

  const { data, error } = await httpClient.GET("/v1/tenants/{tenantId}", {
    params: { path: { tenantId } },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};
